// extracted by mini-css-extract-plugin
export default {"page":"tGKOp","inner":"ImReg","divider":"YY75r","main":"fF5ai"};